<template>
  <el-menu-item v-if="!item.hidden" :index="`${sysPath}/` + basePath">{{ item.meta.title }}</el-menu-item>
</template>

<script>
export default {
  name: "navbarItem",
  props: {
    // route object
    item: {
      type: Object,
      required: true,
    },
    basePath: {
      type: String,
      default: "",
    },
  },
  data() {
    return {};
  },

  mounted() {},

  computed: {
    sysPath() {
      const sysRoute = this.$router.options.routes.find((e) => e.name === "sys");
      return sysRoute ? sysRoute.path : "/sys";
    },
  },
};
</script>

<style lang="scss" scoped></style>
